import { Routes as Router, Route } from "react-router-dom";
import { PrivateRoute, AdminRoute, PermissionRoute } from "./Route";

import { SignIn } from "../pages/SignIn";
import { ResetPassword } from "../pages/ResetPassword";
import { ResetPasswordConfirm } from "../pages/ResetPassword/ResetPasswordConfirm";
import { Home } from "../pages/Home";
import { Dashboard } from "../pages/Dashboard";
import { Costumers } from "../pages/Costumers";
import { Equipments } from "../pages/Equipments";
import { Services } from "../pages/Services";
import { Sectors } from "../pages/Sectors";
import { Users } from "../pages/Users";
import { Responsibles } from "../pages/Responsibles";
import { Zones } from "../pages/Zones";
import { CostumersMap } from "../pages/CostumersMap";
import { EmergencyObservations } from "../pages/EmergencyObservations";
import { Profiles } from "../pages/Profiles";
import { ProfileForm } from "../pages/Profiles/ProfileForm";
import { Permissions } from "../pages/Permissions";

import { EquipmentEdit } from "../pages/Equipments/EquipmentEdit/EquipmentEdit";
import { SectorEdit } from "../pages/Sectors/SectorEdit/SectorEdit";
import { CostumerEdit } from "../pages/Costumers/CostumerEdit/CostumerEdit";
import { UserEdit } from "../pages/Users/UserEdit/UserEdit";
import { ServiceEdit } from "../pages/Services/ServiceEdit/ServiceEdit";
import { ResponsibleEdit } from "../pages/Responsibles/ResponsibleEdit/ResponsibleEdit";
import { ZoneEdit } from "../pages/Zones/ZoneEdit";
import { ZoneAssignCostumers } from "../pages/Zones/ZoneAssignCostumers";
import { SecretMap } from "../pages/SecretMap";
import { TechVisitReport } from "../pages/TechVisitReport";
import { TechVisitReportCreateUnified } from "../pages/TechVisitReport/TechVisitReportForms/TechVisitReportCreateUnified";
import { TestPage } from "../pages/TestPage";
import { TechVisitReportEdit } from "../pages/TechVisitReport/TechVisitReportForms/TechVisitReportEdit";
import { TechVisitReportPDF } from "../pages/TechVisitReport/TechVisitReportPDF/TechVisitReportPDF";
import { CostumersMonitoring } from "../pages/CostumersMonitoring";
import { Profile } from "../pages/Profile";
import { ManagerialReport } from "../pages/ManagerialReport";
import { ManagerialReportPrint } from "../pages/ManagerialReport/Print";
import { DeliveryReportCreate } from "../pages/DeliveryReport";
import { Layout } from "../components/Layout";
import { SmartRedirect } from "../components/SmartRedirect";

export function Routes(): JSX.Element {
  return (
    <Router>
      <Route path="/signin" element={<SignIn />} />
      <Route path="/forgot-password" element={<ResetPassword />} />
      <Route
        path="/reset-password/confirm"
        element={<ResetPasswordConfirm />}
      />
      <Route path="/tests" element={<TestPage />} />
      <Route path="/top-secret" element={<SecretMap />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <SmartRedirect />
          </PrivateRoute>
        }
      />
      <Route
        path="/home"
        element={
          <PrivateRoute>
            <Layout>
              <Home />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/emergency-observations"
        element={
          <PrivateRoute>
            <Layout>
              <EmergencyObservations />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <AdminRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </AdminRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Layout>
              <Profile />
            </Layout>
          </PrivateRoute>
        }
      />

      {/* Rotas de Perfis e Permissões */}
      <Route
        path="/profiles"
        element={
          <PermissionRoute permission="profiles:read" allowAdmin>
            <Profiles />
          </PermissionRoute>
        }
      />
      <Route
        path="/profiles/create"
        element={
          <PermissionRoute permission="profiles:create" allowAdmin>
            <ProfileForm />
          </PermissionRoute>
        }
      />
      <Route
        path="/profiles/edit/:id"
        element={
          <PermissionRoute permission="profiles:update" allowAdmin>
            <ProfileForm />
          </PermissionRoute>
        }
      />
      <Route
        path="/permissions"
        element={
          <PermissionRoute permission="permissions:read" allowAdmin>
            <Permissions />
          </PermissionRoute>
        }
      />

      <Route path="/costumers">
        <Route
          path=""
          element={
            <PrivateRoute>
              <Layout>
                <Costumers />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new"
          element={
            <PrivateRoute>
              <Layout>
                <CostumerEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <PrivateRoute>
              <Layout>
                <CostumerEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="monitoring"
          element={
            <PermissionRoute permission="costumers-monitoring:view" allowAdmin>
              <Layout>
                <CostumersMonitoring />
              </Layout>
            </PermissionRoute>
          }
        />
        <Route
          path="map"
          element={
            <PermissionRoute permission="costumers-map:view" allowAdmin>
              <Layout>
                <CostumersMap />
              </Layout>
            </PermissionRoute>
          }
        />
      </Route>

      <Route path="/equipments">
        <Route
          path=""
          element={
            <PrivateRoute>
              <Layout>
                <Equipments />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <PrivateRoute>
              <Layout>
                <EquipmentEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new"
          element={
            <PrivateRoute>
              <Layout>
                <EquipmentEdit />
              </Layout>
            </PrivateRoute>
          }
        />
      </Route>

      <Route path="/services">
        <Route
          path=""
          element={
            <PrivateRoute>
              <Layout>
                <Services />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <PrivateRoute>
              <Layout>
                <ServiceEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new"
          element={
            <PrivateRoute>
              <Layout>
                <ServiceEdit />
              </Layout>
            </PrivateRoute>
          }
        />
      </Route>

      <Route path="/zones">
        <Route
          path=""
          element={
            <PrivateRoute>
              <Layout>
                <Zones />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <PrivateRoute>
              <Layout>
                <ZoneEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new"
          element={
            <PrivateRoute>
              <Layout>
                <ZoneEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="assign-costumers"
          element={
            <PrivateRoute>
              <Layout>
                <ZoneAssignCostumers />
              </Layout>
            </PrivateRoute>
          }
        />
      </Route>

      <Route path="/sectors">
        <Route
          path=""
          element={
            <PrivateRoute>
              <Layout>
                <Sectors />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <PrivateRoute>
              <Layout>
                <SectorEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new"
          element={
            <PrivateRoute>
              <Layout>
                <SectorEdit />
              </Layout>
            </PrivateRoute>
          }
        />
      </Route>

      <Route path="/responsibles">
        <Route
          path=""
          element={
            <PrivateRoute>
              <Layout>
                <Responsibles />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <PrivateRoute>
              <Layout>
                <ResponsibleEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new"
          element={
            <PrivateRoute>
              <Layout>
                <ResponsibleEdit />
              </Layout>
            </PrivateRoute>
          }
        />
      </Route>

      <Route path="/users">
        <Route
          path=""
          element={
            <PrivateRoute>
              <Layout>
                <Users />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <PrivateRoute>
              <Layout>
                <UserEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new"
          element={
            <PrivateRoute>
              <Layout>
                <UserEdit />
              </Layout>
            </PrivateRoute>
          }
        />
      </Route>

      <Route path="/tech-visit-reports">
        <Route
          path=""
          element={
            <PrivateRoute>
              <Layout>
                <TechVisitReport />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new"
          element={
            <PrivateRoute>
              <Layout>
                <TechVisitReportCreateUnified />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new/:id"
          element={
            <PrivateRoute>
              <Layout>
                <TechVisitReportCreateUnified />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <PrivateRoute>
              <Layout>
                <TechVisitReportEdit />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route path="pdf/:id" element={<TechVisitReportPDF />} />
      </Route>

      <Route path="/delivery-reports">
        <Route
          path="new"
          element={
            <PrivateRoute>
              <Layout>
                <DeliveryReportCreate />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="new/:id"
          element={
            <PrivateRoute>
              <Layout>
                <DeliveryReportCreate />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="edit/:id"
          element={
            <PrivateRoute>
              <Layout>
                <DeliveryReportCreate />
              </Layout>
            </PrivateRoute>
          }
        />
      </Route>

      <Route
        path="/managerial-report"
        element={
          <PermissionRoute permission="managerial-report:view" allowAdmin>
            <Layout>
              <ManagerialReport />
            </Layout>
          </PermissionRoute>
        }
      />
      <Route
        path="/managerial-report/print"
        element={<ManagerialReportPrint />}
      />
    </Router>
  );
}
